import React, { useRef } from "react";
import { Banner } from "src/page-components/opportunities/Banner";
import { RevolutionizeApproach } from "src/page-components/opportunities/RevolutionizeApproach";
import { HowItWorks } from "src/page-components/opportunities/HowItWorks";
import { QuestionsAndAnswers } from "src/page-components/opportunities/QuestionsAndAnswers";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { MetadataWrapper } from "src/components/MetadataWrapper";

const Opportunities = () => {
  const sectionRef = useRef(null);

  return (
    <MetadataWrapper name="opportunities">
      <PageWrapper
        mainClassName="flex flex-col gap-10 gl:gap-20 pb-10 gl:pb-20"
        isShownHeader={false}
      >
        <Banner sectionRef={sectionRef} />
        <RevolutionizeApproach sectionRef={sectionRef} />
        <HowItWorks />
        <QuestionsAndAnswers />
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default Opportunities;
